import {toUUID, UUID} from '../graphql/uuid';

// The reason for using function overloads (aka multiple function signatures)
// is to let the return TYPE of the function to match the input.
// aka if the type of id is ALWAYS a string, the return type is ALWAYS UUID.
// otherwise, the return type is UUID | null.

function validateUUID(id: string): UUID;
function validateUUID(id: UUID): UUID;
function validateUUID(id: null | undefined): null;
function validateUUID(id: string | null): UUID | null;
function validateUUID(id: string | undefined): UUID | null;
function validateUUID(id: string | null | undefined): UUID | null;
function validateUUID(id: string | UUID | null | undefined): UUID | null;
function validateUUID(id: string | UUID | null | undefined): UUID | null {
  if (!id) {
    return null;
  }
  if (typeof id === 'string') {
    if (id.length === 36) {
      return toUUID(id);
    }
    return null;
  }
  if (typeof id === 'object') {
    return id;
  }
  return null;
}
export default validateUUID;
